(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-velaris-testimonials]').forEach((carousel) => {
    if (carousel.dataset.initialized === 'true' || reducedMotion) return;
    carousel.dataset.initialized = 'true';

    const track = carousel.querySelector('[data-velaris-testimonials-track]');
    if (!track || track.children.length < 2) return;

    const originals = Array.from(track.children);
    originals.forEach((card) => track.append(card.cloneNode(true)));

    const speed = Number(carousel.dataset.speed) || 40;
    const pauseOnHover = carousel.dataset.pauseOnHover === 'true';
    let position = 0;
    let halfWidth = 0;
    let lastFrame = performance.now();
    let paused = false;

    const measure = () => { halfWidth = track.scrollWidth / 2; };
    const setPaused = (value) => { paused = value; };

    if (pauseOnHover) {
      carousel.addEventListener('mouseenter', () => setPaused(true));
      carousel.addEventListener('mouseleave', () => setPaused(false));
      carousel.addEventListener('focusin', () => setPaused(true));
      carousel.addEventListener('focusout', () => setPaused(false));
      carousel.addEventListener('touchstart', () => setPaused(true), { passive: true });
      carousel.addEventListener('touchend', () => setPaused(false));
    }

    window.addEventListener('resize', measure);
    window.addEventListener('load', measure, { once: true });
    measure();

    const animate = (now) => {
      const elapsed = (now - lastFrame) / 1000;
      lastFrame = now;

      if (!paused && halfWidth > 0) {
        position -= speed * elapsed;
        if (-position >= halfWidth) position += halfWidth;
        track.style.transform = `translateX(${position}px)`;
      }

      window.requestAnimationFrame(animate);
    };

    window.requestAnimationFrame(animate);
  });
})();
